export const routes = {
  home: '/',
  login: '/login',
  register: '/register',
  otp: '/otp',
  referralCode: '/referral-code',
  registerSuccess: '/register-success',
  couponDetail: '/coupon-detail',
  coupons: '/coupons',
  stampList: '/stamps',
  redeem: '/redeem',
  news: '/news',
  account: '/account',
  transactionHistory: '/transaction-history',
  wallet: '/wallet',
  receiptSubmissions: '/receipt-submissions',
  memberPrivileges: '/member-privileges',
} as const;

export const publicRoutes = [
  routes.login,
  routes.register,
  routes.otp,
  routes.referralCode,
  routes.registerSuccess,
] as const;

export const protectedRoutes = [
  routes.home,
  routes.couponDetail,
  routes.coupons,
  routes.stampList,
  routes.redeem,
  routes.news,
  routes.account,
  routes.transactionHistory,
  routes.wallet,
  routes.receiptSubmissions,
] as const;

// Type for route names
export type RouteName = keyof typeof routes;

// Helper function to get route path
export const getRoute = (routeName: RouteName): string => {
  return routes[routeName];
};

// Helper function to check if route is public
export const isPublicRoute = (pathname: string): boolean => {
  return publicRoutes.includes(pathname as any);
};

// Helper function to check if route is protected
export const isProtectedRoute = (pathname: string): boolean => {
  return protectedRoutes.includes(pathname as any);
}; 